import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled, { ThemeProvider } from "styled-components";
import { theme } from "../theme";
import { Router, Switch } from "react-router-dom";
import AppRoute from "./AppRoute";
import history from "../router/history";
import { ToastContainer, cssTransition } from "react-toastify";
import { MatIcon } from "fiver-react-ui-components";
import GlobalStyle from "./GlobalStyle";

import Contest from "./feature/contest/Wrapper";
import Leaderboard from "./feature/leaderboard/Wrapper";
import Wallet from "./feature/wallet/Wallet";
import WalletCardResult from "./feature/wallet/WalletCardResult";
import Profile from "./feature/profile/Profile";
import NotFound from "./feature/app/404";
import SsoError from "./feature/auth/SsoError";
import LoginWall from "./feature/auth/LoginWall";
import Verify from "./feature/auth/Verify";
import Forgot from "./feature/auth/Forgot";
import Password from "./feature/auth/Password";

import { loadAppStuff } from "components/feature/app/actions";

import {
  useCheckAuth,
  useGetLocation,
  useCreateTheme,
  useScrolledDown,
  useTranslations,
} from "hooks";

import "react-toastify/dist/ReactToastify.css";

const StyledContainer = styled.div`
  width: 100%;

  @media (min-width: ${(props) => props.theme.screenWidthMd}) {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
  }
`;

const StyledCloseButton = styled(MatIcon)`
  position: absolute;
  top: 50%;
  right: 1.5rem;
  transform: translateY(-50%);
`;

// const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
//   cluster: process.env.REACT_APP_PUSHER_CLUSTER,
// });

const slideTransition = cssTransition({
  enter: "slideUp",
  exit: "slideDown",
});

const slideNewTransition = cssTransition({
  enter: "slideUpNew",
  exit: "slideDownNew",
});

const Root = (props) => {
  const dispatch = useDispatch();

  const { isScrolledDown, language } = useSelector((state) => state.app);
  const { isLoggedIn } = useSelector((state) => state.auth);

  useCheckAuth();
  useGetLocation();
  useScrolledDown();

  const [translations] = useTranslations(
    process.env.REACT_APP_LANGUAGE || language,
    true
  );
  const [theme] = useCreateTheme();
  const [betbarParent, setBetbarParent] = useState({});
  const [picksData, setPicksData] = useState({});
  const [isClearingPicks, setClearingPicks] = useState(false);

  const handleSetBetbar = (payload) => {
    setBetbarParent({
      ...betbarParent,
      ...payload,
    });
  };

  const handleClearPicksButtonClicked = () => {
    setClearingPicks(true);
    console.log("handleClearPicksButtonClicked");
  };

  const handlePicksCleared = () => {
    setClearingPicks(false);
    setPicksData({
      ...picksData,
      questionsAnswered: 0,
    });
    console.log("handlePicksCleared");
  };

  useEffect(() => {
    const unload = async () => {
      await window.xtremepush(
        "tag",
        "app_close",
        JSON.stringify({
          AppName: process.env.REACT_APP_TITLE,
        })
      );
      return undefined;
    };
    window.addEventListener("beforeunload", unload);
    return () => {
      window.removeEventListener("beforeunload", unload);
    };
  }, []);

  useEffect(() => {
    // if (localStorage.getItem("fiver_react_access_token")) {
    dispatch(loadAppStuff());
    // }
  }, []);

  return (
    <Router history={history}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <ToastContainer
          closeButton={<StyledCloseButton size="30px">close</StyledCloseButton>}
          autoClose={3000}
          limit={1}
          position="bottom-center"
          hideProgressBar
          // transition={slideNewTransition}
        />

        <StyledContainer>
          <Switch>
            <AppRoute
              path="/"
              topbarBurgerMenu
              topbarTitle={translations?.myPicks}
              bottombar={isLoggedIn}
              hasToolbar
              onClearButtonClicked={handleClearPicksButtonClicked}
              onPicksCleared={handlePicksCleared}
              isClearingPicks={isClearingPicks}
              betbarParent={betbarParent}
              setBetbarParent={setBetbarParent}
              picksData={picksData}
              setPicksData={setPicksData}
              exact
              component={Contest}
              needsPaddingTop
            />
            <AppRoute
              needsPaddingTop
              path="/sso-error"
              exact
              hideTopbar
              hideLegalFooter
              hasPrimaryBackground
              component={SsoError}
            />
            <AppRoute path="/login" exact component={LoginWall} />
            <AppRoute path="/signup" exact component={LoginWall} />
            <AppRoute path="/forgot" bottombar exact component={Forgot} />
            <AppRoute
              path="/verify"
              setPicksData={setPicksData}
              bottombar
              exact
              component={Verify}
            />
            <AppRoute
              path="/change-password"
              bottombar
              exact
              component={Password}
            />
            <AppRoute
              path="/leaderboard"
              topbarBurgerMenu
              topbarTitle={translations.leaderboard}
              bottombar
              hasToolbar
              exact
              hideLegalFooter
              betbarParent={betbarParent}
              setBetbarParent={handleSetBetbar}
              isLeaderboard
              component={Leaderboard}
            />
            <AppRoute
              path="/wallet"
              topbarBurgerMenu
              topbarTitle={translations.wallet}
              bottombar
              exact
              component={Wallet}
            />
            <AppRoute path="/card-result" component={WalletCardResult} />
            <AppRoute
              path="/profile"
              topbarBurgerMenu
              topbarTitle={translations.profile}
              bottombar
              exact
              component={Profile}
              betbarParent={betbarParent}
              setBetbarParent={setBetbarParent}
            />
            <AppRoute topbarBackButton topbarTitle="404" component={NotFound} />
          </Switch>
        </StyledContainer>
      </ThemeProvider>
    </Router>
  );
};

export default Root;
